import { useState, useEffect } from 'react';
import { useQuery, useApolloClient, gql } from '@apollo/client';

import { VIEWER_QUERY } from '@general/graphql/viewer.graph';
import { getMemberFullName } from '@general/entities/member';

const useViewer = queryOptions => {
    const { loading, error, data, refetch } = useQuery(VIEWER_QUERY, queryOptions);
    const [viewer, setViewer] = useState();
    const client = useApolloClient();

    useEffect(() => {
        if (!data?.viewer) {
            setViewer(data?.viewer);
            return;
        }

        const isTrustee = data.viewer.activeCommitteesFull?.some(
            committee => committee.code?.includes('BDTR') && committee.position === 'TRUSTEE'
        );

        setViewer({
            ...data.viewer,
            // remove this eventually? fix for weird issue where photo is http, probably just a one-off on staging - all should be https
            photoUrl: data.viewer.photoUrl?.includes('http://')
                ? data.viewer.photoUrl.replace('http://', 'https://')
                : data.viewer.photoUrl,
            fullName: getMemberFullName(data.viewer.firstName, data.viewer.lastName, data.viewer.suffix),
            isTrustee,
        });
    }, [data]);

    // only really necessary on first upload of a photo
    // once a photo is uploaded, the url stays the same and it just overwritten
    // so saving it to s3 updates it.
    const updatePhotoUrlLocalCache = photoUrl => {
        const dataViewer = client.readQuery({ query: VIEWER_QUERY });

        client.writeFragment({
            id: `Viewer:${dataViewer.viewer.id}`,
            fragment: gql`
                fragment JustPhotoUrl on Viewer {
                    photoUrl
                }
            `,
            data: {
                photoUrl,
            },
        });
    };

    return {
        loading,
        error,
        viewer,
        refetch,
        updatePhotoUrlLocalCache,
    };
};

export default useViewer;
